module.exports = __webpack_public_path__ + "img/akron.7f2ad2f3.png";